// extracted by mini-css-extract-plugin
export default {"activeReviewerContainer":"active-reviewer-module__activeReviewerContainer--zN85C"};